import { memo, type ReactElement } from 'react'

function PasswordIcon (): ReactElement {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 640 512">
      <path
        d="M315.7 302.4l-24.2-3.8-17.3 17.3L254.1 336H224 176v48 16H160 112v48 16H48V385.9L196.1 237.8l17.3-17.3-3.8-24.2c-1-6.6-1.6-13.4-1.6-20.3c0-70.7 57.3-128 128-128s128 57.3 128 128s-57.3 128-128 128c-6.9 0-13.7-.5-20.3-1.6zM272 384h1.9l7-7 27.2-27.2c9.1 1.4 18.4 2.2 27.9 2.2c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 9.5 .7 18.8 2.2 27.9L7 359l-7 7V376v88 24 24H24 48h64 24 24V496v-8V464 448h16 24 8 16V432v-8V400 384h40 8zm96-208a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        className="fill-current text-wpy-gray"
      />
    </svg>
  )
}

export default memo(PasswordIcon)
